module.exports = __webpack_public_path__ + "static/media/logo-intersistemas.502f7bc7.png";